import React from "react";
import { Spinner } from "react-bootstrap";

const Spinners = () => {
  return (
    <div className="position-absolute top-50 start-50">
      <Spinner animation="border" />
    </div>
  );
};

export default Spinners;
